import React from 'react';
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import MuiTable from "../common/MuiTable";
import {
    deleteCalibrationSchedule,
    saveOrUpdateCalibrationSchedule,
    calibrationSchedule,
    uploadFile,
    calibrationScheduleRevision,
    exportReport
} from "../../util/ApiUtils";
import {NotificationManager, NotificationContainer} from "react-notifications";
import DocumentControlHeader from "./CalibrationScheduleDocumentControlHeader";
import {Spinner} from "../common/Spinner";
import { t } from '../../i18n';
import {expiredDateStyleForMuiTable} from "../../util/CommonUtils";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        title: 'id',
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    {
        title: 'certificateId',
        field: 'certificateId',
        type: "numeric",
        hidden: true,
    },
    {
        title: t('calibration.columns.equipmentTitle'),
        field: 'title',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: t('calibration.columns.serialNo'),
        field: 'serialNo',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: t('calibration.columns.locationOfEquipment'),
        field: 'location',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: t('calibration.columns.calibratedOrVerified'),
        field: 'calibratedOrVerified',
        lookup: { yes : t('common.yes') , no : t('common.no') }
    },
    {
        title: t('calibration.columns.titleOfStandard'),
        field: 'titleOfStandard',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: t('calibration.columns.calibrationInterval'),
        field: 'calibrationInterval',
        type: "string",
        cellStyle: {
            width: '15%'
        }
    },
    {
        title: t('calibration.columns.expiryDate'),
        field: 'calibrationExpiry',
        type: "date",
        cellStyle: (value) => {
            return {
                width: '15%',
                ...expiredDateStyleForMuiTable(value)
            }
        }
    },
    {
        title: t('calibration.columns.certificate'),
        field: 'file',
        render: rowData => <span id={rowData.id}/>,
        type: 'fileupload',
    },
];

class CalibrationSchedule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            calibrationSchedule: [],
            isLoading: true,
        };
        this.loadCalibrationSchedule = this.loadCalibrationSchedule.bind(this);
        this.handleSaveOrUpdate = this.handleSaveOrUpdate.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.isValid = this.isValid.bind(this);
        this.handleFileUpload = this.handleFileUpload.bind(this);
    }

    componentDidMount() {
        this.loadCalibrationSchedule();
    }

    loadCalibrationSchedule(callback) {
        calibrationSchedule()
            .then(response => {
                console.log(response);
                this.setState({
                    calibrationSchedule: response,
                    latestRevision: response.latestRevisionDto,
                });
                if (callback) {
                    callback();
                }
            })
            .catch(error => {
                console.log(error);
            });
        calibrationScheduleRevision()
            .then(response => {
                console.log('Revision');
                console.log(response);
                this.setState({
                    latestRevision: response,
                    isLoading: false,
                });
                if (callback) {
                    callback();
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    handleSaveOrUpdate(calibrationScheduleDtoRequest) {
        console.log(calibrationScheduleDtoRequest);
        saveOrUpdateCalibrationSchedule(calibrationScheduleDtoRequest)
            .then((updatedCalibrationSchedule) => {
                console.log("updatedCalibrationSchedule id " + updatedCalibrationSchedule.id);
                console.log("updatedCalibrationSchedule " + updatedCalibrationSchedule);
                console.log(this.state);
                if (calibrationScheduleDtoRequest.file) {
                    this.handleFileUpload(updatedCalibrationSchedule.id, calibrationScheduleDtoRequest.file);
                } else {
                    this.loadCalibrationSchedule();
                }
                NotificationManager.success(t('app.notifications.success'), t('messages.calibrationScheduleUpdated'), 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    handleDelete(calibrationScheduleDtoRequest) {
        console.log(calibrationScheduleDtoRequest);
        deleteCalibrationSchedule(calibrationScheduleDtoRequest)
            .then(() => {
                this.loadCalibrationSchedule();
                NotificationManager.success(t('app.notifications.success'), t('messages.calibrationScheduleUpdated'), 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    isValid(newData) {
        let isValid = newData.title && newData.title !== '';
        if (!isValid) {
            NotificationManager.error(t('app.notifications.error'), t('messages.validation.titleRequired'), 5000);
        }
        return isValid;
    }

    handleFileUpload(calibrationScheduleRecordId, selectedFile) {
        const callback = (status, res) => {
            console.log("result " + status);
            console.log("result " + res);
            if (status === 200) {
                this.loadCalibrationSchedule();
                //NotificationManager.success('Success', 'File has been successfully uploaded!', 5000);
            } else {
                console.log(res);
                //NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
            }
        };
        uploadFile("/calibration-schedule/fileUpload", calibrationScheduleRecordId, selectedFile, callback);
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div>
            <DocumentControlHeader revision={state.latestRevision} isReadOnly={isDemo || isAuditor || isViewer}>
                <Paper className={classes.root} style={{ marginTop: '30px' }}>
                    <MuiTable
                        title={state.latestRevision && state.latestRevision.completedBy && state.latestRevision.conductedOn && t('calibration.title')}
                        columns={columns}
                        data={state.calibrationSchedule}
                        onAdd={this.handleSaveOrUpdate}
                        onUpdate={this.handleSaveOrUpdate}
                        onDelete={this.handleDelete}
                        exportButton={!isDemo && !isViewer}
                        onExport={() => exportReport('/calibration-schedule/export')}
                        isValid={this.isValid}
                        handleFileUpload={this.handleFileUpload}
                        allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                    />
                </Paper>
            </DocumentControlHeader>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(CalibrationSchedule);